import { Col, Form, Input, Row, Switch } from 'antd';
import { reduxForm } from 'antd-form-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { styleGutterRow } from '../../common/configConstants';
import * as actions from './redux/actions';

export class FormRegistro extends Component {
  static propTypes = {
    usuarioPerfil: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = () => {
    this.props.submitForm(this.props.form);
  }

  render() {
    //const { getFieldDecorator, } = this.props.form;
    const { usuarioPerfil, formRef, form: { getFieldDecorator }, formReadOnly = false } = this.props;
    return (
      <div className="usuario-perfil-form-registro">
        <Form layout='vertical' ref={formRef} onSubmit={this.handleSubmit}>
          <Row gutter={styleGutterRow}>
            {
              formReadOnly ? (
                <Col span={18}>
                  <Form.Item label="Perfil">
                    {getFieldDecorator('Nome', {
                      initialValue: usuarioPerfil.registro.Nome,
                      rules: [{ required: true, message: 'Campo obrigatório!' }],
                    })(
                      <span>{usuarioPerfil.registro.Nome}</span>
                    )}
                  </Form.Item>
                </Col>
              ) : (
                <Col span={18}>
                  <Form.Item label="Perfil">
                    {getFieldDecorator('Nome', {
                      initialValue: usuarioPerfil.registro.Nome,
                      rules: [{ required: true, message: 'Campo obrigatório!' }],
                    })(
                      <Input placeholder={usuarioPerfil.registro.Nome} />
                    )}
                  </Form.Item>
                </Col>
              )
            }
            <Col span={6}>
              <Form.Item label="Ativo">
                {getFieldDecorator('Ativo', {
                  initialValue: usuarioPerfil.registro.Ativo || false,
                  rules: [{ required: true }],
                  valuePropName: 'checked',
                })(
                  <Switch />
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Descrição">
                {getFieldDecorator('Descricao', {
                  initialValue: usuarioPerfil.registro.Descricao,
                })(
                  <Input.TextArea rows={5} placeholder={usuarioPerfil.registro.Descricao} />
                )}
              </Form.Item>
            </Col>
            
            <Col md={24}>
              <Form.Item label="Perfil Administrador">
                {getFieldDecorator('perfilAdministrador', {
                  initialValue: usuarioPerfil.registro.perfilAdministrador || false,
                  rules: [{ required: true }],
                  valuePropName: 'checked',
                })(<Switch />)}
              </Form.Item>
            </Col>

            <Col span={18}>
              <Form.Item label="IDM GROUP">
                {getFieldDecorator('GP_IDM_GRP_AD', {
                  initialValue: usuarioPerfil.registro.GP_IDM_GRP_AD,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input placeholder={usuarioPerfil.registro.GP_IDM_GRP_AD} />
                )}
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item label="Ordem">
                {getFieldDecorator('GP_IDM_ORDEM', {
                  initialValue: usuarioPerfil.registro.GP_IDM_ORDEM,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input placeholder={usuarioPerfil.registro.GP_IDM_ORDEM} />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    usuarioPerfil: state.usuarioPerfil,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

FormRegistro = reduxForm({
  form: 'Editar-UsuarioPerfil',
})(FormRegistro);

FormRegistro = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormRegistro);

export default FormRegistro;



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/FormRegistro.js